export default __webpack_public_path__ + "static/media/typeTruck.53198154.53198154.svg";